import { useQuery } from '@tanstack/react-query';
import { handleErrorResponse } from '../../utils/handleError';
import { fetchTodaysHealthStatus } from '../../apis/survey';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useFetchHealthStatus = (patientId: any, date: string) => {
  const { data, isError, isLoading, isRefetching, error } = useQuery({
    queryKey: ['health-status', patientId, date],
    queryFn: () => fetchTodaysHealthStatus(patientId, date),
    enabled: !!patientId,
  });

  if (isError) {
    handleErrorResponse(error, 'Error Fetching Appointments');
  }

  const healthStatus = data?.data || [];

  return {
    isLoading,
    isError,
    isRefetching,
    healthStatus,
  };
};

export default useFetchHealthStatus;
